import React from 'react';

import Header from 'components/Header/index';
import Main from 'components/Main/index';

const Home = () => {
  return (
    <React.Fragment>
      <Header />

      <Main />
    </React.Fragment>
  );
};

export default Home;
